import { render } from "./BlModelExporterSaveModel.vue?vue&type=template&id=253a6df3&scoped=true"
import script from "./BlModelExporterSaveModel.vue?vue&type=script&lang=js"
export * from "./BlModelExporterSaveModel.vue?vue&type=script&lang=js"

import "./BlModelExporterSaveModel.vue?vue&type=style&index=0&id=253a6df3&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253a6df3"]])

export default __exports__